import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=670089e0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=670089e0&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670089e0"]])

export default __exports__